<div *ngIf="!inBuildMode" style="display: none;">
    <input type="hidden"  class="textfield" readonly="readonly" [value]="value"/>  
</div>